import styles from "./vendors.module.scss";
import * as React from "react";
import Header from "@components/Header";
import Footer from "@components/Footer";
import VendorsSection2 from "@components/VendorsSection2";
import VendorsHero from "@components/VendorsHero";
import VendorsSection1 from "@components/VendorsSection1";

const Vendors = () => {
  React.useEffect(() => {
    // GSDevTools.create();
  }, []);

  return (
    <div className={styles["vendors"]} data-scroll-section>
      <h1
        style={{
          position: "absolute",
          width: "1px",
          height: "1px",
          padding: 0,
          margin: "-1px",
          overflow: "hidden",
          clip: "rect(0, 0, 0, 0)",
          whiteSpace: "nowrap",
          border: 0,
        }}
      >
        Inawo vendors platform
      </h1>
      <Header />
      <VendorsHero />
      <VendorsSection1 />
      <VendorsSection2 />
      <Footer vendorsPage />
    </div>
  );
};

export default Vendors;
